(function () {
  var NATIVE_SIZE_FIELDSET_SELECTOR = 'variant-radios fieldset.variant-input-wrapper[data-option-slug="size" i]';
  var CHART_SELECTOR = '.ks-chart-container, .sizing-chart-container';
  var INSTALLMENT_FORM_SELECTOR = 'form[id^="product-form-installment-"]';
  var PRICE_SELECTOR = '[id^="price-"]';
  var FLAG_CLASS = 'fame-size-with-chart';

  function relocateChart() {
    var fieldset = document.querySelector(NATIVE_SIZE_FIELDSET_SELECTOR);
    var chart = document.querySelector(CHART_SELECTOR);
    if (!fieldset || !chart) return false;

    var legend = fieldset.querySelector('legend');
    if (!legend) return false;

    if (legend.contains(chart) && fieldset.classList.contains(FLAG_CLASS)) return true;

    legend.appendChild(chart);
    fieldset.classList.add(FLAG_CLASS);
    return true;
  }

  function relocateInstallments() {
    var installmentForm = document.querySelector(INSTALLMENT_FORM_SELECTOR);
    var priceEl = document.querySelector(PRICE_SELECTOR);
    if (!installmentForm || !priceEl) return false;

    if (installmentForm.previousElementSibling === priceEl) return true;

    priceEl.parentNode.insertBefore(installmentForm, priceEl.nextElementSibling);
    return true;
  }

  function applyVisibility() {
    var radios = document.querySelectorAll('.product__info-container variant-radios');
    radios.forEach(function (el) {
      if (el.style.display !== 'block') el.style.setProperty('display', 'block', 'important');
      el.classList.remove('no-js-hidden');
    });
    var swatchKings = document.querySelectorAll('.product__info-container variant-swatch-king');
    swatchKings.forEach(function (el) {
      if (el.style.display !== 'none') el.style.setProperty('display', 'none', 'important');
    });
  }

  function ensureCustomWishlist() {
    var priceEl = document.querySelector('.product__info-container [id^="price-"] .price');
    if (!priceEl) return false;

    var existing = priceEl.querySelector('.fame-wishlist-btn');
    if (!existing) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'fame-wishlist-btn';
      btn.setAttribute('aria-label', 'Add to wishlist');
      btn.innerHTML = '<svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var swymBtn = document.querySelector('.swym-add-to-wishlist');
        if (swymBtn) swymBtn.click();
        btn.classList.toggle('fame-wishlist-btn--active');
      });
      priceEl.appendChild(btn);
      priceEl.classList.add('fame-price-with-wishlist');
    }
    return true;
  }

  function centerKiwiModals() {
    var candidates = document.querySelectorAll('[class*="kiwi"], [class*="ks-"], [id*="kiwi"], [id*="ks-"]');
    candidates.forEach(function (el) {
      var cls = (typeof el.className === 'string' ? el.className : '') + '';
      if (cls.indexOf('modal-link') !== -1 || cls.indexOf('chart-container') !== -1 ||
          cls.indexOf('calculator-container') !== -1 || cls.indexOf('-svg') !== -1 ||
          cls.indexOf('chart-modal-link') !== -1 || cls.indexOf('ks-chart-container') !== -1) {
        return;
      }
      var style = window.getComputedStyle(el);
      if (style.position !== 'fixed' && style.position !== 'absolute') return;
      if (el.offsetWidth < 240 || el.offsetHeight < 120) return;
      var rect = el.getBoundingClientRect();
      if (rect.width >= window.innerWidth * 0.6 || rect.height >= window.innerHeight * 0.4) {
        el.style.setProperty('display', 'flex', 'important');
        el.style.setProperty('align-items', 'center', 'important');
        el.style.setProperty('justify-content', 'center', 'important');
      }
    });
  }

  function run() {
    applyVisibility();
    relocateChart();
    relocateInstallments();
    ensureCustomWishlist();
    centerKiwiModals();
  }

  function init() {
    run();

    var observer = new MutationObserver(function () {
      run();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
